import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useToastContext } from '../../../../contexts'
import { DeliveryForecastDespatchAdvicePackaging } from '../../../../data/models'
import { getHandleableError } from '../../../../utils/errors/isXiaError'
import { useConfigContext } from '../../../ui-config'
import { useAllDeliveryForecastDespatchAdviceItems } from '../../data'
import { requestCreateDeliveryForecastDespatchAdviceItemPackaging } from '../../data/api'
import {
  useAllDeliveryForecastDespatchAdviceItemPackagings,
  useDeliveryForecastDespatchAdviceItemPackagingById,
} from '../../data/hooks'
import { ShippingDetailsView } from './ShippingDetails.view'

type Props = {
  despatchAdviceId: string
}
export const ShippingDetailsData: React.FC<Props> = ({ despatchAdviceId }) => {
  const { t } = useTranslation()

  const { uiConfig: config } = useConfigContext()
  const [isRequestRunning, setIsRequestRunning] = useState(false)
  const { showToast } = useToastContext()

  const { data, isLoading } =
    useAllDeliveryForecastDespatchAdviceItems(despatchAdviceId)

  // Get all packagings
  const { data: packagings, isLoading: isPackagingsLoading } =
    useAllDeliveryForecastDespatchAdviceItemPackagings(
      despatchAdviceId,
      data?.[0]?.Id!,
    )

  // Get first packaging
  const { data: packaging, isLoading: isPackagingLoading } =
    useDeliveryForecastDespatchAdviceItemPackagingById(
      despatchAdviceId,
      data && data[0] && data?.[0]?.Id,
      packagings && packagings[0] && packagings?.[0].Id,
    )

  const createPackagingTable = async (
    despatchAdviceId: string,
    itemId: string,
  ) => {
    const newPackage: DeliveryForecastDespatchAdvicePackaging = {
      Id: 'newPackage',
      DespatchAdviceItemId: data?.[0].Id!,
      DesAdvPosition: data?.[0].DesAdvPosition,
      Items: [],
    }

    try {
      setIsRequestRunning(true)

      await requestCreateDeliveryForecastDespatchAdviceItemPackaging(
        despatchAdviceId,
        itemId,
        newPackage,
      )

      showToast({
        severity: 'success',
        summary: t(
          'deliveryForecastDespatchAdvice.shippingDetails.add.messages.success.summary',
        ),
        detail: t(
          'deliveryForecastDespatchAdvice.shippingDetails.add.messages.success.detail',
        ),
      })
    } catch (error) {
      const handleableError = getHandleableError(error)
      const errorMessage = handleableError.message

      showToast({
        severity: 'error',
        summary: t(
          'deliveryForecastDespatchAdvice.shippingDetails.add.messages.failure.summary',
        ),
        detail: errorMessage,
        sticky: true,
      })
    } finally {
      setIsRequestRunning(false)
    }
  }

  // if (isLoading) return <></>

  return (
    <ShippingDetailsView
      despatchAdviceId={despatchAdviceId}
      itemId={data?.[0]?.Id!}
      id={packaging?.Id!}
      config={config}
      packaging={packaging}
      createPackagingTable={createPackagingTable}
      isRequestRunning={isRequestRunning}
      isLoading={isLoading || isPackagingsLoading || isPackagingLoading}
    />
  )
}
